export default __webpack_public_path__ + "static/media/portfolio-191.211f379d.jpg";